import React from "react";

const TextArea = ({
  label,
  placeholder,
  name,
  required = false,
  className,
  outerClassName,
  value,
  colorize = false,
  rows = 4,
  ...props
}) => {
  // Determine if value is a number and its sign
  const parsedValue = parseFloat(value);
  const isNumber = !isNaN(parsedValue);
  const isNegative = isNumber && parsedValue < 0;
  const isPositive = isNumber && parsedValue > 0;

  // Conditional classes for text and border color
  const textColorClass = colorize
    ? isNegative
      ? "text-red-500"
      : isPositive
      ? "text-green-500"
      : ""
    : "";
  const borderColorClass = colorize
    ? isNegative
      ? "border-red-500"
      : isPositive
      ? "border-green-500"
      : "border-app-border"
    : "border-app-border";

  return (
    <>
      {label && (
        <label
          className="block uppercase text-app-text-secondary text-xs font-bold mb-2"
          htmlFor={label}
        >
          {label || "label"} {required && <sup className="text-red-500">*</sup>}
        </label>
      )}
      <div
        className={`border rounded w-full transition-all duration-150 border-app-border ${
          props.disabled
            ? "bg-app-surface-muted cursor-not-allowed opacity-70"
            : "bg-app-surface text-app-text focus-within:ring focus-within:ring-primary/30"
        } ${borderColorClass} ${outerClassName}`}
      >
        <textarea
          className={`placeholder:text-app-text-muted bg-transparent text-sm p-2 rounded w-full  text-app-text ${
            props.disabled
              ? "cursor-not-allowed bg-app-surface-muted text-app-text-muted placeholder-gray-400"
              : "focus:outline-none focus:ring-0"
          } ${textColorClass} ${className}`}
          placeholder={placeholder || label}
          name={name}
          required={required}
          value={value ?? ""}
          rows={rows}
          {...props}
          onFocus={(event) => !props.disabled && event.target.select()}
        />
      </div>
    </>
  );
};

export default TextArea;
